import { Button } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

interface CloseBillProps {
    closeBill: () => void;
    disabled: boolean;
}

export const CloseBill: React.FC<CloseBillProps> = ({ closeBill, disabled }) => (
    <Button
        variant="primary"
        data-test-close-bill-button
        onClick={closeBill}
        disabled={disabled}
        size="medium"
        wide
        type="submit"
    >
        <LocalizedText textKey={TextKey.BillClose} />
    </Button>
);
